
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../../../page/categories/categories.component';


@Component({
    selector: 'app-add-category-dialog',
    templateUrl: './add-category-dialog.component.html',
    styleUrls: ['./add-category-dialog.component.scss'],
    standalone: false ,  // NOSONAR
})
export class AddCategoryDialogComponent implements OnInit {


	selectedValue;
	selectedOption: number = 0;
	fileUploaded: File;
	storeData: any;
	worksheet: any;
	data: any;
	action;
	local_data;
	initial_data;
	pageName;
	error;
	enableError: boolean = false;
	heading;


	constructor(public dialogRef: MatDialogRef<AddCategoryDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public dataStore: DialogData) {

		console.info("data store", dataStore);

		this.pageName = dataStore.page;

		if (this.dataStore.performAction == 'AddCell') {  // NOSONAR
			this.action = 'AddCell';
			this.heading = "Add";
		}

		else if (this.dataStore.performAction == 'EditCell') {  // NOSONAR
			this.action = 'EditCell';
			this.initial_data = this.dataStore.placeholder;
			this.local_data = this.initial_data;
			this.heading = "Edit";
		}

	}

	ngOnInit(): void { // NOSONAR
		//  do something 
	}


	public onChange(event): void {  // event will give you full breif of action
		this.selectedValue = event.target.value;
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	close(): void {
		this.dialogRef.close();
	}


	public saveClick() {

		if (this.local_data == '' || this.local_data == null || this.local_data == undefined || this.local_data.trim().length == 0) {  // NOSONAR
			this.error = "error";
			this.enableError = true;
		}

		else {

			this.dialogRef.close({ event: this.action, data: this.local_data });

		}


	}




}




